import { lazyRoute } from "@/routes/lazy-route";

const LabelSettingsPage = lazyRoute(() => import("./label-settings.page"), "LabelSettingsPage");

export const labelSettingsRoutes = [
  {
    path: "label",
    element: <LabelSettingsPage />,
  },
];
